/**
 * PasswordInput — a password field with a Show / Hide button (Stage 3 polish, 1 Oct 2026).
 * Takes the same props as <input>; only `type` is controlled here.
 */
import React, { useState } from 'react';

const PasswordInput = ({ style, ...props }) => {
  const [show, setShow] = useState(false);
  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <input {...props} type={show ? 'text' : 'password'} style={{ ...style, paddingRight: 64, width: '100%', boxSizing: 'border-box' }} />
      <button type="button" onClick={() => setShow((s) => !s)} aria-label={show ? 'Hide password' : 'Show password'}
        aria-pressed={show} tabIndex={0}
        style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', background: 'transparent',
                 border: 'none', color: '#00B4D8', fontSize: 13, fontWeight: 600, cursor: 'pointer', padding: '6px 8px' }}>
        {show ? 'Hide' : 'Show'}
      </button>
    </div>
  );
};

export default PasswordInput;
